import { ApolloCache, gql } from '@apollo/client';
import { MutationUpdaterFunction } from '@apollo/client/core/types';
import { IMutation } from '@pass-frontend/data-access/common/edge';

export const MEMBER_LAST_LOCATION_MUTATION = gql`
  mutation MEMBER_LAST_LOCATION_MUTATION(
    $summary: String
    $latitude: Float
    $longitude: Float
  ) {
    updateMemberLastLocation(
      summary: $summary
      latitude: $latitude
      longitude: $longitude
    ) {
      summary
      latitude
      longitude
    }
  }
`;

const currentMemberLocationFragment = gql`
  fragment CURRENT_MEMBER_LOCATION_FRAGMENT on Query {
    currentMember {
      lastLocation {
        summary
        latitude
        longitude
      }
    }
  }
`;
/**
 * This function is necessary for the updated member location to be recorded in the client
 * (otherwise it is only recorded on the server and not available until page reload)
 * @param cache
 * @param updateMemberLastLocation
 */
export const updateOnMemberLastLocationMutation: MutationUpdaterFunction<
  {
    updateMemberLastLocation: ReturnType<IMutation['updateMemberLastLocation']>;
  },
  unknown,
  unknown,
  ApolloCache<unknown>
> = (cache, { data: { updateMemberLastLocation } }) => {
  // writeFragment does *not* circumvent the merge function, unlike the prior implementation
  //  and the merge function now does the distance eviction when necessary

  const ROOT_QUERY_ID = cache.identify({
    __typename: 'Query',
  });

  cache.writeFragment({
    id: ROOT_QUERY_ID,
    fragment: currentMemberLocationFragment,
    data: {
      currentMember: {
        lastLocation: {
          ...updateMemberLastLocation,
        },
      },
    } as any,
  });
};
